import React from "react";

function NavBar() {
  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      {/* Brand Logo */}
      <a href="/" className="brand-link">

        <span className="brand-text">Mototrad</span>
      </a>

      {/* Sidebar */}
      <div className="sidebar">
        {/* Sidebar user panel (optional) */}

        {/* Sidebar Menu */}
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column nav-flat nav-child-indent"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            {/* Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library */}
            <li className="nav-item">
              <a href="/" className="nav-link active">
                <i className="nav-icon fas fa-tachometer-alt"></i>
                <p>Dashboard</p>
              </a>
            </li>
            <li className="nav-header">Products & Categories</li>
            <li className="nav-item has-treeview">
              <a href="/products/list" className="nav-link">
                <i className="nav-icon fas fa-store"></i>
                <p>
                  Products
                  <i className="fas fa-angle-left right"></i>
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <a href="/products/list" className="nav-link">
                    <i className="far fa-circle nav-icon"></i>
                    <p>All Products</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/products/create" className="nav-link">
                    <i className="far fa-circle nav-icon"></i>
                    <p>Add New Product</p>
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item has-treeview">
              <a href="/categories/list" className="nav-link">
                <i className="nav-icon fas fa-tags"></i>
                <p>
                  Categories
                  <i className="fas fa-angle-left right"></i>
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <a href="/categories/list" className="nav-link">
                    <i className="far fa-circle nav-icon"></i>
                    <p>All Categories</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/categories/create" className="nav-link">
                    <i className="far fa-circle nav-icon"></i>
                    <p>Add New Category</p>
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-header">Auction & Orders</li>

            <li className="nav-item">
              <a href="/orders/list" className="nav-link">
                <i className="nav-icon fas fa-shopping-cart"></i>
                <p>
                  Orders
                  {/* <span className="badge badge-info right">2</span> */}
                </p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/bids/list" className="nav-link">
                <i className="nav-icon fas fa-truck"></i>
                <p>
                  Bids
                  {/* <span className="badge badge-info right">2</span> */}
                </p>
              </a>
            </li>
            <li className="nav-header">Contacts</li>
            <li className="nav-item">
              <a href="/" className="nav-link">
                <i className="nav-icon fas fa-envelope"></i>
                <p>Contacts</p>
              </a>
            </li>
            <li className="nav-header">Users Info</li>
            <li className="nav-item ">
              <a href="/users/list" className="nav-link">
                <i className="nav-icon fas fa-users"></i>
                <p>
                  Users
                  <i className="fas fa-angle-left right"></i>
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <a href="/users/list" className="nav-link">
                    <i className="far fa-circle nav-icon"></i>
                    <p>All Users</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/users/create" className="nav-link">
                    <i className="far fa-circle nav-icon"></i>
                    <p>Add New User</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/users/list" className="nav-link">
                    <i className="far fa-circle nav-icon"></i>
                    <p>Profile</p>
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-header">Settings</li>
            <li className="nav-item ">
              <a href="/generalSettings" className="nav-link">
                <i className="nav-icon fas fa-cog"></i>
                <p>
                  General Settings
                  {/* <i className="fas fa-angle-left right"></i> */}
                </p>
              </a>
            </li>
          </ul>
        </nav>
        {/* /.sidebar-menu */}
      </div>
      {/* /.sidebar */}
    </aside>
  );
}

export default NavBar;
